import React, { useEffect, useState } from 'react';
import taskService from 'services/http/task-service';
import usersService from 'services/http/users-service';
import teamsService from 'services/http/teams-service';
import { SkeletonLoader, CustomAutoComplete, CustomButton, DropdownTemplate } from 'components/shared';
import utils, { CUSTOM_MESSAGES } from 'utils';
import $ from 'jquery';

const TRANSFER_TYPES = { AGENTS: "Agents", COMPETENCES: "Competences", TEAMS: "Teams", LANG: "Languages" };
const ITEMS_FIELDS = { USERNAME: "username", TEAM: "teamName", COMPETENCE: "competenceName", LANGUAGE: "description" };

export const TaskTransfer = (props) => {

    const [selectedTypeItem, setSelectedTypeItem] = useState();

    return (
        <div>
            {
                <div className={"transfer-layout"}>
                    <div className="d-flex text-center">
                        <h7 className="mt-2" style={{ whiteSpace: "nowrap" }}>Select the transfer category</h7>
                        <DropdownTemplate
                            options={[{ value: TRANSFER_TYPES.AGENTS }, { value: TRANSFER_TYPES.TEAMS }, { value: TRANSFER_TYPES.COMPETENCES }, { value: TRANSFER_TYPES.LANG }]}
                            optionLabel="value"
                            placeholder="Transfer type"
                            selectedItem={selectedTypeItem}
                            className="custom-dropdown"
                            //PREVENT CONTENT OVERLPPING WITH HEIGHT SCROLL
                            onFocus={() => $(".transfer-layout").height(180)}
                            onItemChange={(e) => setSelectedTypeItem(e.value)}
                        />
                    </div>
                    {
                        selectedTypeItem &&
                        <TransferItemAutoCompelete
                            task={props.task}
                            type={selectedTypeItem}
                            successCallback={props.successCallback}
                            errorCallback={props.errorCallback} />
                    }
                </div>
            }
        </div>
    );
}



const TransferItemAutoCompelete = (props) => {

    const [loadingSubmission, setLoadingSubmission] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [filtredItems, setFiltredItems] = useState([]);
    const [allItems, setAllItems] = useState();
    const [loading, setLoading] = useState(false);
    const [fieldItem, setFieldItem] = useState();

    useEffect(() => {
        setLoading(true);
        setSelectedItems([]);
        switch (props.type) {
            case TRANSFER_TYPES.AGENTS: {
                usersService.getAgentsUsername().then((response) => {
                    setAllItems(response.result.map((username) => { let item = {}; item["username"] = username; return item}));
                    setFieldItem(ITEMS_FIELDS.USERNAME);
                }, error => {
                    alert(error);
                }).finally(() => {
                    setLoading(false);
                });
                break;
            }
            case TRANSFER_TYPES.TEAMS: {
                teamsService.getTeams().then((response) => {
                    setAllItems(response.result);
                    setFieldItem(ITEMS_FIELDS.TEAM);
                }, error => {
                    alert(error);
                }).finally(() => {
                    setLoading(false);
                });
                break;
            }
            case TRANSFER_TYPES.COMPETENCES: {
                usersService.getCompetences().then((response) => {
                    setAllItems(response.result);
                    setFieldItem(ITEMS_FIELDS.COMPETENCE);
                }, error => {
                    alert(error);
                }).finally(() => {
                    setLoading(false);
                });
                break;
            }
            case TRANSFER_TYPES.LANG: {
                usersService.getLanguages().then((response) => {
                    setAllItems(response.result);
                    setFieldItem(ITEMS_FIELDS.LANGUAGE);
                }, error => {
                    alert(error);
                }).finally(() => {
                    setLoading(false);
                });
                break;
            }
            default: {
                break;
            }
        }
    }, [props.type]);

    const searchItem = (e) => {
        setTimeout(() => {
            let _filtredItems;
            if (!e.query.trim().length) {
                _filtredItems = [...allItems];
            }
            else {
                _filtredItems = allItems.filter((tag) => {
                    return tag[fieldItem]?.toLowerCase().includes(e.query.toLowerCase());
                });
            }
            setFiltredItems(_filtredItems);
        }, 250);
    }

    const onSubmit = (e) => {
        let items;
        switch (props.type) {
            case TRANSFER_TYPES.AGENTS: {
                let agents = selectedItems.map(item => { return { username: item.username } });
                items = { agents, size: agents.length };
                break;
            }
            case TRANSFER_TYPES.TEAMS: {
                let teams = selectedItems.map(item => { return { teamId: item.teamId } });
                items = { teams, size: teams.length };
                break;
            }
            case TRANSFER_TYPES.COMPETENCES: {
                let competences = selectedItems.map(item => { return { competenceId: item.competenceId } });
                items = { competences, size: competences.length };
                break;
            }
            case TRANSFER_TYPES.LANG: {
                let languages = selectedItems.map(item => { return { languageId: item.languageId } });
                items = { languages, size: languages.length };
                break;
            }
            default: {
                break;
            }
        }
        if (items.size) {
            setLoadingSubmission(true);
            delete items.size;
            taskService.updatetaskStatus({
                taskId: props.task.id,
                status: props.task.status,
                view: props.view,
                payload: items
            }).then(response => {
                props.successCallback(response.message);
            }, error => {
                props.errorCallback(error);
            }).finally(() => {
                setLoadingSubmission(false);
            });
        } else {
            props.errorCallback(CUSTOM_MESSAGES.NO_ITEM_SELECTED);
        }
        e.preventDefault();
    }

    return (
        <>
            {loading ? <SkeletonLoader factor={1} /> :
                <div>
                    <CustomAutoComplete
                        id="items-autocomplete"
                        className="appender-dropdown"
                        value={selectedItems}
                        suggestions={filtredItems}
                        completeMethod={searchItem}
                        field={fieldItem}
                        placeholder={props.type}
                        scrollHeight={filtredItems?.length > 3 ? "100px" : "fit-content"}
                        icon="bi bi-box-arrow-up-right"
                        onChange={(e) => { setSelectedItems(e.value); }}
                        multiple
                        dropdown
                        light
                    />
                    <div className="my-3 text-center">
                        <CustomButton
                            label={utils.labelTemplate(<><i className="bi bi-check-circle" /> Submit</>, loadingSubmission, "Processing...")}
                            style={{ width: "60%" }}
                            className={loadingSubmission && "not-allowed"}
                            onClick={(e) => { onSubmit(e) }} />
                    </div>
                </div>
            }
        </>
    );
}